<div class="tc-accordion">
  <ng-container *ngIf="content$ | async as content">
    <mat-expansion-panel>
      <mat-expansion-panel-header
        class="panel-header"
        [collapsedHeight]="collapsedHeight"
        [expandedHeight]="expandedHeight"
      >
        <mat-panel-title>
          {{ content.header }}
        </mat-panel-title>
      </mat-expansion-panel-header>
      <p [innerHTML]="content.content"></p>
    </mat-expansion-panel>
  </ng-container>
</div>
